import { IAccordionHeader, ITableDataRow } from '../../types';
import { getFormula } from '../../utils';

interface IProps {
  headers: IAccordionHeader[] | undefined;
}
export const getDepreciationTable = (props: IProps) => {
  const { headers = [] } = props;
  const datas = [];
  const rows: ITableDataRow[] = [];
  const formulaResult = getFormula('DEPRECIATION_FORMULA', {
    ...props,
  });
  if (formulaResult.method == 'sum') return [];
  let rate: number;
  if (formulaResult.method == 'dbm') rate = formulaResult.rate;
  else rate = formulaResult.salvage;
  const years = formulaResult.dur;
  let openingValue: number = formulaResult.cost;
  const depreciationStraight: number = Math.round(
    openingValue * (formulaResult.salvage / 100)
  );
  let depreciationDBM: number = formulaResult.depYear;
  for (let i = 0; i < years; ++i) {
    const rowValueOpening = '₹' + Math.abs(openingValue).toFixed(0);
    if (formulaResult.method == 'dbm')
      depreciationDBM = Math.round(
        (openingValue - depreciationStraight) * (rate / 100)
      );
    const rowValueDepreciation = '₹' + Math.abs(depreciationDBM).toFixed(0);
    const closingValue = Math.round(openingValue - depreciationDBM);
    const rowValueClosing = '₹' + Math.abs(closingValue).toFixed(0);
    const row = [
      {
        value: i + 1,
        className: 'bg-white',
      },
      {
        value: rowValueOpening,
        className: 'bg-white',
      },
      {
        value: rowValueDepreciation,
        className: 'bg-white',
      },
      {
        value: rowValueClosing,
        className: 'bg-white',
      },
    ];
    rows.push({
      data: row,
    });
    openingValue = closingValue;
  }
  datas.push({
    type: 'table',
    title: '',
    data: [
      {
        headers: headers,
        rows: rows,
      },
    ],
  });

  return datas;
};
